// {
//     "id": "b7588996-73af-4c3f-a9da-0192723a35c1",
//     "direction": "received",
//     "type": "application/vnd.iris.ticket+json",
//     "content": {
//         "id": "b7588996-73af-4c3f-a9da-0192723a35c1",
//         "sequentialId": 5,
//         "ownerIdentity": "desk230824ditpgmzzquqrva4mhtb@msging.net",
//         "customerIdentity": "3b400436-b76f-4e9c-98a0-044525d3f497@tunnel.msging.net",
//         "customerDomain": "wa.gw.msging.net",
//         "provider": "Lime",
//         "status": "Waiting",
//         "storageDate": "2024-10-09T17:01:10.467Z",
//         "externalId": "b7588996-73af-4c3f-a9da-0192723a35c1",
//         "rating": 0,
//         "team": "Default",
//         "unreadMessages": 0,
//         "closed": false,
//         "customerInput": {
//             "type": "text/plain",
//             "value": "2"
//         },
//         "priority": 0
//     },
//     "date": "2024-10-09T17:01:10.607Z",
//     "status": null
// },
export type TicketContent =
    | string
    | {
          sequentialId: number;
          ownerIdentity: string;
          customerIdentity: string;
          customerDomain: string;
          provider: string;
          status: string;
          storageDate: string;
          externalId: string;
          rating: number;
          team: string;
          unreadMessages: number;
          closed: boolean;
          customerInput: { type: string; value: string };
          priority: number;
          interactive?: {
              action: {
                  buttons?: {
                      reply: { title: string; id: string };
                  }[];
              };
              type: string;
              body: { text: string };
          };
      };

export enum TicketMessageDirection {
    Sent = 'sent',
    Received = 'received',
}
export enum TicketStatus {
    Consumed = 'consumed',
    Dispached = 'dispatched',
}

export type TicketMessage = {
    id: string;
    direction: TicketMessageDirection;

    type: string;
    content: TicketContent;
    date: string;
    status: TicketStatus | null;
};

export type TicketMessageResponse = {
    totalItems: number;
    items: TicketMessage[];
};
